export type UnitSystem = 'inches' | 'mm';

export interface ArcInputs {
	unit: UnitSystem;
	chordLength: number | null;
	radiusOrDiameter: number | null;
	inputMode: 'radius' | 'diameter';
	tolPlus: number | null;
	tolMinus: number | null;
}

export interface SagittaResult {
	nominal: number;
	upperLimit?: number;
	lowerLimit?: number;
	tolPlus?: number;
	tolMinus?: number;
	inputRadius: number;
	inputChord: number;
	inputTolPlus?: number;
	inputTolMinus?: number;
	isSymmetric?: boolean;
	hasToleranceDisplay: boolean;
}

export const PRECISION_LEVELS: Record<
	UnitSystem,
	{ decimals: number; label: string }[]
> = {
	inches: [
		{ decimals: 3, label: 'Thousandths (0.000)' },
		{ decimals: 4, label: 'Ten-thousandths (0.0000)' },
	],
	mm: [
		{ decimals: 2, label: 'Hundredths (0.00)' },
		{ decimals: 3, label: 'Thousandths (0.000)' },
	],
};

export const UNIT_SUFFIX: Record<UnitSystem, string> = {
	inches: 'in',
	mm: 'mm',
};
